import PropTypes from "prop-types";
import React from "react";
import "./CodeSample.css";

const CodeSample = props => (
  <div className="codeSample">
    <code>{props.children}</code>
  </div>
);

CodeSample.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CodeSample;



// WEBPACK FOOTER //
// ./src/components/CodeSample/CodeSample.js